import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom';
import LegalsFooter from 'components/modules/footer/LegalsFooter';


const LoginFooter = ({ identification, creation, showOffers }) => (
    <>
    <div className="loginFooter">
        <div className="bottomWave">
            <div className="identifyBlock">
                {identification && 
                    <div className="textFooter"><Link to='/login'>{window['webAppContent'].GENERIC.CONNECT}</Link></div>
                }
                {creation && 
                    <div className="textFooter">{window['webAppContent'].FOOTER.NOT_REGISTERED} <Link to="/create-user">{window['webAppContent'].GENERIC.REGISTER_BTN}</Link></div>
                }
                {showOffers && 
                    <div className="textFooter">{window['webAppContent'].GENERIC.OR_TEXT}<Link to='/list-coupons'> {window['webAppContent'].FOOTER.SEE_COUPONS_BTN}</Link></div>
                }
            </div>
        </div>
    </div>
    <LegalsFooter />
    </>
  )

  LoginFooter.propTypes = {
    identification: PropTypes.bool,
    creation: PropTypes.bool,
    showOffers: PropTypes.bool
  }

export default LoginFooter;